import { useSelector } from "react-redux"
import { RootState } from "../app/store"
import { Link } from "react-router-dom"
import BeInTouch from "../components/BeInTouch"
import Footer from "../components/Footer/Footer"
import placeholder from "../assets/plchldr.jpg"

import { Helmet } from "react-helmet"

const Posts = () => {
  const posts = useSelector((state: RootState) => state.posts.items)

  return (
    <>
      <Helmet>
        <title>Blog | Muhammed Mashady - Latest Insights</title>
        <meta
          name="description"
          content="Read the latest blog posts and articles by Muhammed Mashady covering web development, technology, and software engineering."
        />
        <meta property="og:title" content="Blog | Muhammed Mashady" />
        <meta property="og:description" content="Latest insights on web development and software engineering." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
      </Helmet>
      <div className="max-w-[1240px] mx-auto pt-12 px-4">
        <h1 className="text-3xl font-bold mb-8">Latest Posts ✍️</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 mb-16">
          {posts.map((post) => (
            <Link to={`/post?id=${post.id}`} key={post.id} className="group">
              <div className="main-bg rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300">
                <img 
                  src={post.picture || placeholder} 
                  alt={post.title} 
                  className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="p-6">
                  <div className="text-[#6b69f2] text-sm font-bold uppercase mb-2">
                    {post.category || "General"}
                  </div>
                  <h2 className="text-xl font-bold mb-3 group-hover:text-[#6b69f2] transition-colors">
                    {post.title}
                  </h2>
                  <p className="text-[#79747b] line-clamp-3 mb-4">
                    {post.description}
                  </p>
                  <div className="text-xs text-gray-500">
                    {new Date(post.createdAt).toLocaleDateString()}
                  </div>
                </div>
              </div>
            </Link>
          ))}
          {posts.length === 0 && (
            <div className="col-span-full text-center py-20 text-gray-500">
              No posts yet. Stay tuned!
            </div>
          )}
        </div>
        <hr className="border-[#79747b] border-opacity-25" />
        <BeInTouch />
      </div>
      <Footer />
    </>
  )
}

export default Posts
